<script lang="ts">
	import bib from '$assets/errors/bib-error.webp';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';
	import ModalDialog from '../modals/ModalDialog.svelte';

	const searchParams = getSearchParamsStore();

	interface Props {
		open?: boolean;
		onShowLocaleModal: () => void;
	}

	let { open = $bindable(false), onShowLocaleModal }: Props = $props();

	function close() {
		open = false;
		$searchParams.showModal = undefined;
	}

	function showLocaleModal() {
		onShowLocaleModal();
		close();
	}
</script>

<ModalDialog bind:open closeCallback={close} centered contentDialogClasses="!relative p-2">
	{#snippet closeButtonSlot()}
		<Button
			color="white"
			icon="close"
			text={$isMobile ? m.modal__close() : undefined}
			class={$isMobile ? '' : 'absolute top-8 right-8 z-infront'}
			onclick={close}
		/>
	{/snippet}
	<div class="flex flex-col md:flex-row bg-neutral-weakest rd-2 md:rd-4 max-w-196 overflow-hidden">
		<div class="flex flex-col p-8 gap-8">
			<h2 class="text-title-regular">
				Polska wersja ViaMichelin nie jest już obsługiwana.
			</h2>
			<p class="text-container text-md text-coloredneutral-soft">
				<span>
					Przekierowaliśmy Cię na stronę viamichelin.com, gdzie możesz nadal korzystać z naszych usług w języku angielskim lub
					<Button
						size="md"
						color="white"
						variant="filled"
						class="p-0 text-bold contents"
						labelClasses="underline"
						text="wybrać inny język."
						onclick={showLocaleModal} />
				</span>
			</p>
		</div>
		<div class="bg-primary w-full h-43 md:h-auto md:min-h-86 md:w-64 relative">
			<img src={bib} class="absolute bib bottom--12 md:bottom-0 w-55" alt="" />
		</div>
	</div>
</ModalDialog>

<style>
	.bib {
		left: 50%;
		transform: translateX(-50%);
	}

	@media screen and (min-width: 960px) {
		.bib {
			right: 72px;
			left: unset;
			transform: unset;
		}
	}
</style>
